import { defineStore } from 'pinia'


interface ContentRootState {
	initialised: boolean
	working: boolean

	content: {
		blog: GlobalContentType<ContentBlog>
		product: GlobalContentType<ContentProduct>
		testimonial: GlobalContentType<ContentTestimonial>
		event: GlobalContentType<ContentEvent>
	}

	testimonial: Array<{
		titles: Record<string, string>,
		description: {
			short: string,
			long: string
		},
		category: string,
		image: string,
		slug: string,
	}>


	products: Array<{
		titles: Record<string, string>,
		description: {
			short: string,
			long: string
		},
		category: string,
		image: string,
		slug: string,
	}>

	// productCategories: Array<{
	// 	labels: {
	// 		short: string,
	// 		full: string,
	// 	},
	// 	color: string,
	// 	description: string,
	// 	image: string,
	// 	slug: string,
	// 	icon: string,
	// }>

	sds: GlobalContentType<ContentSDS>
}

export const useContentStore = defineStore('content', {

	state: (): ContentRootState => ({
		initialised: true,
		working: false,


		content: {
			// blog: {
			// 	init: false,
			// 	working: false,

			// 	records: [],
			// 	total: 0,
			// 	limit: 10,
			// 	sort: "date",
			// 	order: "desc",
			// 	page: 1
			// },
			product: {
				init: false,
				working: false,

				records: [],
				total: 0,
				limit: 50,
				sort: "date",
				order: "desc",
				page: 1
			},
			testimonial: {
				init: false,
				working: false,
				records: [] as ContentTestimonial[],
				total: 0,
				limit: 100,
				sort: "date",
				order: "asc",
				page: 1,
			},

		},

		productCategories: [
      {
        name: 'Kitchen Products',
        description: 'Powerful detergents, degreasers and sanitisers that keep every kitchen surface spotless, compliant and safe for food preparation.',
        shortDescription: 'Hygiene solutions to keep every kitchen clean and safe.',
        image: '/images/kitchen-2.jpg',
        slug: 'kitchen',
      },
      {
        name: 'House Keeping',
        description: 'A full range of cleaners, fresheners and disinfectants to maintain immaculate guest rooms, bathrooms and public spaces.',
        shortDescription: 'Cleaners and disinfectants for flawless rooms and spaces.',
        image: '/images/bathroom.jpg',
        slug: 'house-keeping',
      },
      {
        name: 'Laundry Products',
        description: 'From detergents to stain removers, our laundry solutions deliver freshness, softness and professional standards every wash.',
        shortDescription: 'Laundry care that delivers freshness and professional results.',
        image: '/images/laundry.jpg',
        slug: 'laundry',
      },
      {
        name: 'Hand Hygiene Products',
        description: 'Alcohol-based gels, soaps and sanitisers designed to protect staff and guests while meeting strict hygiene standards.',
        shortDescription: 'Soaps and sanitisers to protect hands and health.',
        image: '/images/hand-hygeine.jpg',
        slug: 'hand-hygiene',
      },
      {
        name: 'Food & Beverages',
        description: 'Specialist sanitisers and hygiene products to safeguard food and beverage preparation, ensuring quality and compliance.',
        shortDescription: 'Sanitisers to protect food and beverage preparation areas.',
        image: '/images/food.jpg',
        slug: 'food-and-beverages',
      },
      {
        name: 'Disinfectant Wipes',
        description: 'Convenient, medical-grade wipes for quick, effective surface disinfection wherever and whenever it’s needed.',
        shortDescription: 'Quick and effective wipes for everyday disinfection.',
        image: '/images/disinfectant-wipes.jpg',
        slug: 'disinfectant-wipes',
      },
    ],

    services: [
      {
        name: 'Training',
        headline: 'Empower Your Staff',
        description: 'Empower your team with the knowledge and skills to maintain world-class hygiene standards every day.',
        keyPoints: [
          'Safe and effective use of products',
          'Hands-on demonstrations and best practices',
          'Personal hygiene and compliance training'
        ],
        cta: 'Learn More',
        slug: 'training',
        image: '/images/cleaning-team.jpg',
        index: 1
      },
      {
        name: 'Cleaning Plans & Monitoring',
        headline: 'Stay Organised & Compliant',
        description: 'Stay ahead with tailored and accurate cleaning schedules and regular checks that keep your business spotless and compliant.',
        keyPoints: [
          'Customised cleaning schedules for every site',
          'Quality control and hygiene audits',
          'Compliance monitoring and reporting'
        ],
        cta: 'Learn More',
        slug: 'cleaning-plans-and-monitoring',
        image: '/images/checklist-2.jpg',
        index: 2
      },
      {
        name: 'Technical Support & Signage',
        headline: 'Support You Can Trust',
        description: 'Keep your systems running smoothly with expert support, regular visits, and clear compliance signage.',
        keyPoints: [
          'Bi-monthly technical visits and dispenser checks',
          'Emergency maintenance and rapid response',
          'Safety signage and compliance documentation'
        ],
        cta: 'Learn More',
        slug: 'technical-support-and-signage',
        image: '/images/signs.jpg',
        index: 3
      }
    ]




		// productCategories: [
		// 	{
		// 		labels: {
		// 			short: 'Blends',
		// 			full: 'Ethanol & Ethanol Blends',
		// 		},
		// 		color: '#2727e0',
		// 		description: 'Blends',
		// 		image: '/images/1.jpeg',
		// 		slug: 'ethanol',
		// 		icon: '',
		// 	},
		// 	{
		// 		labels: {
		// 			short: 'Chemicals',
		// 			full: 'Essential Chemicals',
		// 		},
		// 		color: 'rgb(89 6 149)',
		// 		description: 'Essential Chemicals',
		// 		image: '/images/1.jpeg',
		// 		slug: 'essential-chemicals',
		// 		icon: '',
		// 	},
		// 	{
		// 		labels: {
		// 			short: 'Manufactured',
		// 			full: 'Manufactured Products',
		// 		},
		// 		color: 'rgb(33 150 196)',
		// 		description: 'Manufactured Products',
		// 		image: '/images/1.jpeg',
		// 		slug: 'manufactured-products',
		// 		icon: '',
		// 	},
		// 	{
		// 		labels: {
		// 			short: 'Synthetic',
		// 			full: 'Synthetic',
		// 		},
		// 		color: 'rgb(179 73 107)',
		// 		description: 'Synthetic',
		// 		image: '/images/1.jpeg',
		// 		slug: 'synthetic',
		// 		icon: '',
		// 	},
		// 	{
		// 		labels: {
		// 			short: 'Bases',
		// 			full: 'Bases',
		// 		},
		// 		color: 'rgb(22 137 133)',
		// 		description: 'Bases',
		// 		image: '/images/1.jpeg',
		// 		slug: 'bases',
		// 		icon: '',
		// 	},
		// ],


	}),

	actions: {
		updateInitialised(initValue: boolean) {
			this.initialised = initValue
		},
	},

	getters: {
		getInitialised: state => state.initialised,
	},
})